import { userStore } from "../store/userStore";
import axiosInstance from "./api";

const {
  REACT_APP_KIOSK_TOKEN: KIOSK_TOKEN,
  REACT_APP_USER_TOKEN: USER_TOKEN,
  REACT_APP_ENVIRONMENT: ENVIRONMENT,
} = process.env;

export function handleKioskoAuthResponse(responseData) {
  const { token, user } = responseData;

  localStorage.setItem(KIOSK_TOKEN, token);

  userStore.getState().setKioskData(user);
}

export function handleAuthResponse(responseData) {
  const { token, expires_at, user } = responseData;

  localStorage.setItem(USER_TOKEN, token);

  const expiresDate = new Date(expires_at.replace(" ", "T")).toISOString();
  localStorage.setItem(USER_TOKEN + "_expires", expiresDate);

  userStore.getState().setUserData(user);
}

export const sessionStatus = async () => {
  const { setKioskData, clearUserData } = userStore.getState();

  try {
    const response = await axiosInstance.get("profile");

    if (response.data) {
      setKioskData(response.data);
    }
    return true;
  } catch (error) {
    localStorage.removeItem(ENVIRONMENT);
    localStorage.removeItem(KIOSK_TOKEN);
    clearUserData();

    window.location.href = "/";
    return false;
  }
};
